import axios from 'axios';

import { MICRO_CMS_API_KEY, MICRO_CMS_API_ORIGIN } from '@/global/env';
import { InformationState } from '@/pages/home/HomePage';

type NewsListContent = {
  id: string;
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
  revisedAt: string;
  title: string;
  body: string;
  created_at: string;
  thumbnail: {
    url: string;
    height: number;
    width: number;
  };
  url: string;
  date: string;
};

type NewsList = {
  totalCount: number;
  offset: number;
  limit: number;
  contents: NewsListContent[];
};

type ProductInformationContent = {
  id: string;
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
  revisedAt: string;
  title: string;
  body: string;
  created_at: string;
  info_state: InformationState;
  is_opened: boolean;
};

type ProductInformation = {
  totalCount: number;
  offset: number;
  limit: number;
  contents: ProductInformationContent[];
};

const config = {
  headers: {
    'Content-Type': 'application/json',
    'X-API-KEY': MICRO_CMS_API_KEY,
  },
};

export const fetchNewsList = async (): Promise<NewsList> => {
  const res = await axios.get<NewsList>(
    `${MICRO_CMS_API_ORIGIN}/api/v1/news`,
    config
  );
  return res.data;
};

export const fetchProductInformationList =
  async (): Promise<ProductInformation> => {
    const res = await axios.get<ProductInformation>(
      `${MICRO_CMS_API_ORIGIN}/api/v1/product-information`,
      config
    );
    return res.data;
  };
